class CartPromotionModal extends HTMLElement {
    constructor() {
        super();
        this.closeButton = this.querySelector(".cart-promotion-modal__close");
        this.overlay = this.querySelector(".cart-promotion-modal__overlay");
        this.atcButton = this.querySelector(".cart-promoion-modal__button");
        this.productButtons = this.querySelectorAll("label");
        this.carttreeshold = this.dataset.carttreeshold
    }
    connectedCallback() {
        this.init()
    }
    setEventListeners() {
        this.overlay.onclick = event => {
            if (event.target === event.currentTarget) {
                this.closeModal()
            }
        };
        this.closeButton.onclick = () => this.closeModal();
        this.productButtons.forEach((button => {
            button.addEventListener("click", (event => {
                this.productButtons.forEach((innerbutton => {
                    innerbutton.classList.remove("cart-promotion-modal__item-active")
                }));
                button.classList.add("cart-promotion-modal__item-active")
            }))
        }));
        this.atcButton.onclick = () => {
            const selectedProductId = this.querySelector(".cart-promotion-modal__item-active").dataset.productid;
            this.checkAndRemoveExistingPromoProducts(selectedProductId)
        }
    }
    init() {
        this.setEventListeners();
        setInterval((() => this.checkCartTotalAndRemovePromos()), 5e3)
    }
    addPromotionProductToCart(productId) {
        console.log(productId, "productId");
        if (document.querySelector('quiz-container')) {
            return;
        }
        if (!productId) {
            return
        }
        const data = {
            id: productId,
            quantity: 1,
            properties: {
                __promoTag: "true",
                __free_product: "true"
            }
        };
        fetch("/cart/add.js", {
            method: "POST",
            headers: {
                "Content-Type": "application/json"
            },
            body: JSON.stringify(data)
        }).then((response => response.json())).then((data => {
            console.log("Success:", data);
            this.closeModal();
            document.dispatchEvent(new CustomEvent("ajaxProduct:added"))
        })).catch((error => {
            console.error("Error:", error)
        }))
    }
    setActiveLabel(id) {
        this.productButtons.forEach((innerbutton => {
            innerbutton.classList.remove("cart-promotion-modal__item-active");
        }));
        let currentProduct = this.querySelector(`[data-productid="${id}"]`);
        if (currentProduct) {
            currentProduct.classList.add("cart-promotion-modal__item-active");
        }
    }
    checkAndRemoveExistingPromoProducts(newProductId) {
        const cart = window.cartData;
        const itemsToRemove = cart.items.filter((item => item.properties?.__promoTag));
        Promise.all(itemsToRemove.map((item => this.removeProductFromCart(item.key)))).then((() => this.addPromotionProductToCart(newProductId))).catch((error => console.error("Error:", error)))
    }
    removeProductFromCart(lineItemId) {
        return fetch(`/cart/change.js`, {
            method: "POST",
            headers: {
                "Content-Type": "application/json"
            },
            body: JSON.stringify({
                id: lineItemId,
                quantity: 0
            })
        }).then((response => {
            if (!response.ok) {
                return response.text().then((text => {
                    throw new Error(`Failed to remove product. Status: ${response.status}. Response: ${text}`)
                }))
            }
            return response.json()
        })).catch((error => console.error("Error:", error)))
    }
    openModal(id) {
        document.dispatchEvent(new Event("cart:close"));
        this.setActiveLabel(id);
        this.style.display = "flex";
        this.overlay.style.display = "block"
    }
    removeAllPromoProducts() {
        const cart = window.cartData;
        const promoItems = cart.items.filter((item => item.properties?.__promoTag));
        Promise.all(promoItems.map((item => this.removeProductFromCart(item.key)))).catch((error => console.error("Error:", error)))
    }
    checkCartTotalAndRemovePromos() {
        const cart = window.cartData;
        const cartTotal = cart.total_price;
        if (cartTotal < parseInt(this.carttreeshold)) {
            this.removeAllPromoProducts()
        }
    }
    async productInCart(productId) {
        const cart = window.cartData;
        return cart.items.some((item => item.variant_id === productId))
    }
    closeModal() {
        this.style.display = "none";
        this.overlay.style.display = "none";
        document.dispatchEvent(new Event("cart:open"))
    }
}
customElements.define("cart-promotion-modal", CartPromotionModal);
class PromoProduct extends HTMLElement {
    constructor() {
        super();
        this.triggerButton = this.querySelector(".upsell-product-checkox");
        this.promotionModal = document.querySelector("cart-promotion-modal");
        this.initialProductId = this.dataset.initialproduct;
        this.hasInCart = this.dataset.hasincart;
    }
    connectedCallback() {
        this.init();
        if (this.hasInCart == "false") {
            this.promotionModal.addPromotionProductToCart(this.initialProductId)
        }
    }
    async ensureInitialProductInCart() {
        const productExists = await this.promotionModal.productInCart(this.initialProductId);
        if (!productExists) {
            this.promotionModal.addPromotionProductToCart(this.initialProductId)
        }
    }
    init() {
        if (this.triggerButton) {
            this.triggerButton.onclick = () => this.promotionModal.openModal(this.initialProductId);
        }
    }
}
if (!customElements.get("promo-product")) {
    customElements.define("promo-product", PromoProduct)
}